import React from 'react';
import { StepWizard } from '../../components/StepWizard';
import { Drawer } from '../../components/Drawer';
import { PhoneFlowContext } from './context';
import { PhoneStep } from '../shared/PhoneStep';
import { usePhoneFlow } from './usePhoneFlow';
import { useBaseFlow } from '../shared/useBaseFlow';
import { AccessCodeStep } from '../shared/AccessCodeStep/';
import { FlowTypes } from '../shared/enums/FlowTypes';

export type PhoneFlowProps = {
  children: React.ReactNode;
};

const PhoneFlowDrawer = (): JSX.Element => {
  const { isOpen, close } = usePhoneFlow();

  return (
    <Drawer open={isOpen} onClose={close}>
      <StepWizard>
        <PhoneStep />
        <AccessCodeStep flowType={FlowTypes.CELLPHONE} />
      </StepWizard>
    </Drawer>
  );
};

const Flow = ({ children }: PhoneFlowProps): JSX.Element => {
  const context = useBaseFlow();

  return (
    <PhoneFlowContext.Provider value={context}>
      <PhoneFlowDrawer />
      {children}
    </PhoneFlowContext.Provider>
  );
};

export { Flow };
